export default __webpack_public_path__ + "assets/images/10c2bd8c0464013d8f408ebb3203cb7d.svg";